import TextInput from "Components/molecule/inputs/text-input"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import FormProps from "data/forms"
import FiscalYearFields from "./types"

const YEAR_KEY = 'year'

const FiscalYearForm = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    isValid,
    touched,
    isSubmitting,
}: FormProps<FiscalYearFields>) => {

    return <div className="generate-documents-form">
        <TextInput
            type="number"
            touched={!!touched.year}
            name={YEAR_KEY}
            key={YEAR_KEY}
            label={"Fiscal Year*"}
            placeholder={"e.g. 2031 (Sep 2030 - Aug 2031)"}
            value={values.year}
            onBlur={handleBlur}
            onChange={handleChange}
            error={!!touched.year && !!errors.year}
            message={touched.year ? errors.year : undefined}
        />

        <p className="text-muted small">
            The fiscal year is named for the year it ends. Its 12 fiscal periods are created with it.
        </p>

        <PrimaryButton
            type='submit'
            onClick={() => handleSubmit()}
            disabled={isSubmitting || !isValid}
            className="w-100"
        >
            {isSubmitting ? "Submitting...." : "Submit"}
        </PrimaryButton>
    </div>
}

export default FiscalYearForm
